export default __webpack_public_path__ + "static/media/IRSensorImg.35747041.jpg";